<template>
  <div id="q-app">
    <router-view />
    <axios-interceptors/>
    <push-handler/>
  </div>
</template>
<script>

import AxiosInterceptors from "components/AxiosInterceptors";
import PushHandler from "components/PushHandler";
import ImageViewerDialog from "components/ImageViewerDialog.vue";

export default {
  name: 'App',
  components: {PushHandler, AxiosInterceptors},
  async mounted() {
    window.handleOpenURL = (url) => {
      this.$router.push(url.replace('womenwellbeing://', '/').replace('#', ''))
    }

    try {
      window.screen.orientation.lock('portrait');
    } catch {

    }

    let that = this

    window.$(document).on('click', '.info-page a, .message-info a, .q-dialog-plugin a', function(e){
      e.preventDefault();

      if($(this).hasClass('info-page-link')) {
        return
      }

      let href = $(this).attr('href')

      if(href.indexOf('https://womenswellbeing.apped.nz') == 0 || href.indexOf('womenswellbeing://') == 0){
        let url = $(this).attr('href').replace('https://womenswellbeing.apped.nz', '').replace('womenswellbeing://', '/').replace('/#/', '/')
        that.$router.push(url)
      } else {
        that.openLink(href)
      }
    })

    this.syncUser(false)

    this.$axiosNoIntercept.get(this.$apiUrl + '/payments_enabled').then(r => {
      this.paymentsEnabled = r.data.result
    })
  },
  methods: {

  }
};
</script>
